import { render, staticRenderFns } from "./AYSTW.vue?vue&type=template&id=440de988&scoped=true&"
import script from "./AYSTW.vue?vue&type=script&lang=js&"
export * from "./AYSTW.vue?vue&type=script&lang=js&"
import style0 from "./AYSTW.vue?vue&type=style&index=0&id=440de988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440de988",
  null
  
)

export default component.exports